import { Project } from './types';

// 示例数据 - 基于 src/index.js 的 INITIAL_PROJECTS
// 用于测试和开发，展示不同区域的数据点颜色
export const SAMPLE_PROJECTS: Project[] = [
  // Layer 4: Strategic GO (All tests passed) - Zone 1 (红色背景，红色数据点)
  {
    id: '1',
    customer_name: 'Tesla',
    project_name: 'Model Q Dashboard',
    region: 'MX',
    date: '2023-10-27',
    rcc5_relevance: 4,
    rcc5_core: 5,
    rcc5_culture: 4,
    rcc5_access: 3,
    rcc5_scale: 5,
    ft1p_product: 5,
    ft1p_design: 4,
    ft1p_tech: 5,
    ft1p_comp: 3,
    ft1p_leadership: 4,
    tco_d: 3,
    tco_t: 3,
    tco_m: 3,
    dpc_1: 4,
    dpc_2: 4,
    dpc_3: 4,
    dpc_4: 4,
    dpc_5: 4,
    dpc2_1: 4,
    dpc2_2: 4,
    dpc2_3: 5,
    dpc2_4: 4,
    dpc2_5: 5,
    dpc3_1: 3,
    dpc3_2: 4,
    dpc3_3: 4,
    dpc3_4: 3,
    dpc3_5: 4,
    cr6_competitor_core: 5,
    cr6_competitor_dependency: 4,
    rcc5_total: 21,
    ft1p_total: 21,
    tco_total: 9,
    dpc_total: 20,
    dpc2_total: 22,
    dpc3_total: 18,
  },
  // Layer 1: Client Reject (RCC5 < 12) - Zone 9 (绿色背景，绿色数据点)
  {
    id: '2',
    customer_name: 'Small Tier-3 Supplier',
    project_name: 'Aftermarket Handle',
    region: 'CN',
    date: '2023-11-01',
    rcc5_relevance: 2,
    rcc5_core: 2,
    rcc5_culture: 2,
    rcc5_access: 2,
    rcc5_scale: 2,
    ft1p_product: 3,
    ft1p_design: 3,
    ft1p_tech: 3,
    ft1p_comp: 3,
    ft1p_leadership: 3,
    tco_d: 3,
    tco_t: 3,
    tco_m: 3,
    dpc_1: 3,
    dpc_2: 3,
    dpc_3: 3,
    dpc_4: 3,
    dpc_5: 3,
    dpc2_1: 3,
    dpc2_2: 3,
    dpc2_3: 3,
    dpc2_4: 3,
    dpc2_5: 3,
    dpc3_1: 3,
    dpc3_2: 3,
    dpc3_3: 3,
    dpc3_4: 3,
    dpc3_5: 3,
    cr6_competitor_core: 3,
    cr6_competitor_dependency: 3,
    rcc5_total: 10,
    ft1p_total: 15,
    tco_total: 9,
    dpc_total: 15,
    dpc2_total: 15,
    dpc3_total: 15,
  },
  // Layer 2: Project Avoid - CR A2 (Minefield) - Zone 1 (红色背景，红色数据点)
  {
    id: '3',
    customer_name: 'BMW',
    project_name: 'X5 Interior Trim',
    region: 'DE',
    date: '2023-11-05',
    rcc5_relevance: 5,
    rcc5_core: 5,
    rcc5_culture: 4,
    rcc5_access: 4,
    rcc5_scale: 5,
    ft1p_product: 5,
    ft1p_design: 4,
    ft1p_tech: 5,
    ft1p_comp: 4,
    ft1p_leadership: 4,
    tco_d: 3,
    tco_t: 3,
    tco_m: 3,
    dpc_1: 4,
    dpc_2: 4,
    dpc_3: 4,
    dpc_4: 4,
    dpc_5: 4,
    dpc2_1: 4,
    dpc2_2: 4,
    dpc2_3: 4,
    dpc2_4: 4,
    dpc2_5: 4,
    dpc3_1: 4,
    dpc3_2: 4,
    dpc3_3: 4,
    dpc3_4: 4,
    dpc3_5: 4,
    cr6_competitor_core: 5,
    cr6_competitor_dependency: 5,
    rcc5_total: 23,
    ft1p_total: 22,
    tco_total: 9,
    dpc_total: 20,
    dpc2_total: 20,
    dpc3_total: 20,
  },
  // Layer 2: Project Avoid - TCO Too High - Zone 2 (蓝色背景，蓝色数据点)
  {
    id: '4',
    customer_name: 'Toyota',
    project_name: 'Camry Complex Lighting',
    region: 'JP',
    date: '2023-11-10',
    rcc5_relevance: 4,
    rcc5_core: 4,
    rcc5_culture: 4,
    rcc5_access: 4,
    rcc5_scale: 5,
    ft1p_product: 4,
    ft1p_design: 4,
    ft1p_tech: 4,
    ft1p_comp: 3,
    ft1p_leadership: 4,
    tco_d: 5,
    tco_t: 5,
    tco_m: 5,
    dpc_1: 4,
    dpc_2: 4,
    dpc_3: 4,
    dpc_4: 4,
    dpc_5: 4,
    dpc2_1: 4,
    dpc2_2: 4,
    dpc2_3: 4,
    dpc2_4: 4,
    dpc2_5: 4,
    dpc3_1: 4,
    dpc3_2: 4,
    dpc3_3: 4,
    dpc3_4: 4,
    dpc3_5: 4,
    cr6_competitor_core: 3,
    cr6_competitor_dependency: 3,
    rcc5_total: 21,
    ft1p_total: 19,
    tco_total: 15,
    dpc_total: 20,
    dpc2_total: 20,
    dpc3_total: 20,
  },
  // Layer 2: Project Avoid - CR B2 (No Future) - Zone 6 (橙色背景，橙色数据点)
  {
    id: '5',
    customer_name: 'Ford',
    project_name: 'F-150 Non-Core Bracket',
    region: 'US',
    date: '2023-11-15',
    rcc5_relevance: 4,
    rcc5_core: 4,
    rcc5_culture: 3,
    rcc5_access: 3,
    rcc5_scale: 4,
    ft1p_product: 2,
    ft1p_design: 2,
    ft1p_tech: 3,
    ft1p_comp: 3,
    ft1p_leadership: 3,
    tco_d: 3,
    tco_t: 3,
    tco_m: 3,
    dpc_1: 3,
    dpc_2: 3,
    dpc_3: 3,
    dpc_4: 3,
    dpc_5: 3,
    dpc2_1: 3,
    dpc2_2: 3,
    dpc2_3: 3,
    dpc2_4: 3,
    dpc2_5: 3,
    dpc3_1: 3,
    dpc3_2: 3,
    dpc3_3: 3,
    dpc3_4: 3,
    dpc3_5: 3,
    cr6_competitor_core: 1,
    cr6_competitor_dependency: 5,
    rcc5_total: 18,
    ft1p_total: 13,
    tco_total: 9,
    dpc_total: 15,
    dpc2_total: 15,
    dpc3_total: 15,
  },
  // Layer 3: Execution Fix - DPC/DPC²/DPC³ Weak - Zone 4 (青色背景，青色数据点)
  {
    id: '6',
    customer_name: 'Volkswagen',
    project_name: 'ID.4 B-Pillar Assembly',
    region: 'DE',
    date: '2023-11-20',
    rcc5_relevance: 4,
    rcc5_core: 4,
    rcc5_culture: 4,
    rcc5_access: 3,
    rcc5_scale: 4,
    ft1p_product: 4,
    ft1p_design: 4,
    ft1p_tech: 4,
    ft1p_comp: 4,
    ft1p_leadership: 4,
    tco_d: 3,
    tco_t: 3,
    tco_m: 3,
    dpc_1: 2,
    dpc_2: 2,
    dpc_3: 2,
    dpc_4: 3,
    dpc_5: 3,
    dpc2_1: 2,
    dpc2_2: 2,
    dpc2_3: 2,
    dpc2_4: 3,
    dpc2_5: 3,
    dpc3_1: 2,
    dpc3_2: 2,
    dpc3_3: 2,
    dpc3_4: 3,
    dpc3_5: 3,
    cr6_competitor_core: 4,
    cr6_competitor_dependency: 2,
    rcc5_total: 19,
    ft1p_total: 20,
    tco_total: 9,
    dpc_total: 12,
    dpc2_total: 12,
    dpc3_total: 12,
  },
  // 额外示例：Zone 3 (黄色背景，黄色数据点)
  {
    id: '7',
    customer_name: 'Mercedes-Benz',
    project_name: 'C-Class Door Panel',
    region: 'DE',
    date: '2023-11-25',
    rcc5_relevance: 5,
    rcc5_core: 5,
    rcc5_culture: 5,
    rcc5_access: 4,
    rcc5_scale: 5,
    ft1p_product: 2,
    ft1p_design: 2,
    ft1p_tech: 2,
    ft1p_comp: 2,
    ft1p_leadership: 2,
    tco_d: 3,
    tco_t: 3,
    tco_m: 3,
    dpc_1: 3,
    dpc_2: 3,
    dpc_3: 3,
    dpc_4: 3,
    dpc_5: 3,
    dpc2_1: 3,
    dpc2_2: 3,
    dpc2_3: 3,
    dpc2_4: 3,
    dpc2_5: 3,
    dpc3_1: 3,
    dpc3_2: 3,
    dpc3_3: 3,
    dpc3_4: 3,
    dpc3_5: 3,
    cr6_competitor_core: 4,
    cr6_competitor_dependency: 3,
    rcc5_total: 24,
    ft1p_total: 10,
    tco_total: 9,
    dpc_total: 15,
    dpc2_total: 15,
    dpc3_total: 15,
  },
  // 额外示例：Zone 5 (紫色背景，紫色数据点)
  {
    id: '8',
    customer_name: 'Audi',
    project_name: 'A4 Console Trim',
    region: 'DE',
    date: '2023-11-28',
    rcc5_relevance: 4,
    rcc5_core: 4,
    rcc5_culture: 3,
    rcc5_access: 4,
    rcc5_scale: 4,
    ft1p_product: 3,
    ft1p_design: 3,
    ft1p_tech: 4,
    ft1p_comp: 3,
    ft1p_leadership: 3,
    tco_d: 3,
    tco_t: 3,
    tco_m: 3,
    dpc_1: 3,
    dpc_2: 3,
    dpc_3: 3,
    dpc_4: 3,
    dpc_5: 3,
    dpc2_1: 3,
    dpc2_2: 3,
    dpc2_3: 3,
    dpc2_4: 3,
    dpc2_5: 3,
    dpc3_1: 3,
    dpc3_2: 3,
    dpc3_3: 3,
    dpc3_4: 3,
    dpc3_5: 3,
    cr6_competitor_core: 3,
    cr6_competitor_dependency: 3,
    rcc5_total: 19,
    ft1p_total: 16,
    tco_total: 9,
    dpc_total: 15,
    dpc2_total: 15,
    dpc3_total: 15,
  },
  // 额外示例：Zone 7 (黄绿背景，黄绿数据点)
  {
    id: '9',
    customer_name: 'Hyundai',
    project_name: 'Sonata Dashboard',
    region: 'KR',
    date: '2023-12-01',
    rcc5_relevance: 3,
    rcc5_core: 3,
    rcc5_culture: 2,
    rcc5_access: 2,
    rcc5_scale: 3,
    ft1p_product: 5,
    ft1p_design: 5,
    ft1p_tech: 5,
    ft1p_comp: 4,
    ft1p_leadership: 4,
    tco_d: 3,
    tco_t: 3,
    tco_m: 3,
    dpc_1: 3,
    dpc_2: 3,
    dpc_3: 3,
    dpc_4: 3,
    dpc_5: 3,
    dpc2_1: 3,
    dpc2_2: 3,
    dpc2_3: 3,
    dpc2_4: 3,
    dpc2_5: 3,
    dpc3_1: 3,
    dpc3_2: 3,
    dpc3_3: 3,
    dpc3_4: 3,
    dpc3_5: 3,
    cr6_competitor_core: 3,
    cr6_competitor_dependency: 3,
    rcc5_total: 13,
    ft1p_total: 23,
    tco_total: 9,
    dpc_total: 15,
    dpc2_total: 15,
    dpc3_total: 15,
  },
  // 额外示例：Zone 8 (琥珀背景，琥珀数据点)
  {
    id: '10',
    customer_name: 'Nissan',
    project_name: 'Altima Bumper',
    region: 'JP',
    date: '2023-12-05',
    rcc5_relevance: 3,
    rcc5_core: 3,
    rcc5_culture: 2,
    rcc5_access: 2,
    rcc5_scale: 3,
    ft1p_product: 3,
    ft1p_design: 3,
    ft1p_tech: 3,
    ft1p_comp: 3,
    ft1p_leadership: 3,
    tco_d: 3,
    tco_t: 3,
    tco_m: 3,
    dpc_1: 3,
    dpc_2: 3,
    dpc_3: 3,
    dpc_4: 3,
    dpc_5: 3,
    dpc2_1: 3,
    dpc2_2: 3,
    dpc2_3: 3,
    dpc2_4: 3,
    dpc2_5: 3,
    dpc3_1: 3,
    dpc3_2: 3,
    dpc3_3: 3,
    dpc3_4: 3,
    dpc3_5: 3,
    cr6_competitor_core: 3,
    cr6_competitor_dependency: 3,
    rcc5_total: 13,
    ft1p_total: 15,
    tco_total: 9,
    dpc_total: 15,
    dpc2_total: 15,
    dpc3_total: 15,
  },
];

